<template>
    <div
        class="d-inline-flex align-items-center flex-nowrap ps-1"
        v-if="club !== null"
    >
        <InputBool
            v-if="showCheckbox"
            v-model="internalValue.UseExternalClub"
            class="me-2"
        />
        {{ club?.Name }}
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import type { RaceContestantDetailsExternalData } from '@/objects/RaceContestantDetailsExternalData';
import InputBool from '../Basic/InputBool.vue';
import { useCommonStoreRef } from '@/stores';

const props = defineProps<{
    /**
     * This is the category name from the source
     */
    value: number | null;

    /**
     * The full row object
     */
    row: RaceContestantDetailsExternalData;
}>();

const { Clubs } = useCommonStoreRef();

const internalValue = ref<RaceContestantDetailsExternalData>(props.row);

// We only show the checkbox if the club values are different
const showCheckbox = computed(() => {
    return props.row.RaceContestantDetails.ClubID != props.row.RegisteredClubID;
});

const club = computed(() => {
    if (!props.value) return null;

    return Clubs.value.find((c) => c.ID === props.value) ?? null;
});
</script>
